import { Injectable } from "@angular/core";
import { AuthHttpService } from "app/users";
import { getApiPath } from "app/common";

@Injectable()
export class CouponHttpService {
  constructor(private authHttp: AuthHttpService) {}

  getCoupons() {
    return this.authHttp.get(`${getApiPath()}payments/individual-coupons/`, {}, true);
  }
}
